import { useSession } from '@Contexts/session';
import { concatUrlSegments } from '@utils/concatUrlSegments';
import { useCallback } from 'react';
import { type NavigateOptions, useNavigate } from 'react-router';

export function useClientNavigate() {
    const navigate = useNavigate();
    const {
        current: { subpath },
    } = useSession();

    return useCallback(
        (path: string | number, options?: NavigateOptions) => {
            if (typeof path === 'number') {
                navigate(path);
            } else if (path.startsWith('.')) {
                // relative
                navigate(path, { ...options, relative: 'path' });
            } else {
                // absolute
                const fullPath = concatUrlSegments(`/${subpath}`, path);
                navigate(fullPath, options);
            }
        },
        [subpath, navigate],
    );
}
